import { ClickAction } from "../dom-actions/click-action/ClickAction";
import { DateHighlighter } from "../dom-actions/DateHighlighter";
import { QRCodeGenerator } from "../../library-templates/qr--code/QRCodeGenerator";
import { SetBackground } from "../dom-actions/set-background/SetBackground";
import { SocialMediaPost } from "../dom-actions/SocialMediaPost";
import { TextEditorElement } from "../text/editor/TextEditorElement";
import { App } from "./App";
import { RenderQuality } from "../../library-templates/render--quality/RenderQuality";

export class Include
{
  static all( app:App )
  {
    RenderQuality.applyOnDocument( app.onAnimationFrame );
    SetBackground.applyOnDocument(); 
    ClickAction.applyOnDocument();

    TextEditorElement.applyOnDocument();

    DateHighlighter.applyOnDocument();
    SocialMediaPost.applyOnDocument();

    QRCodeGenerator.applyOnDocument();
  }
}